import type { VolumeResponse } from '~/shared/types/api';
import type { SelectOption } from '~/shared/utils/types';
import {
  downloadFile,
  generateExportFilename,
  toCsv,
  volumeToExportRowCsv,
  volumeToExportRowJson,
} from '~/shared/utils/exportUtils';

export interface VolumesExportParams {
  countUrl: string;
  dataUrl: string;
  formats: Array<'csv' | 'json'>;
  filtersForName: SelectOption[];
}

interface VolumesExportDeps {
  fetchData: (
    dataUrl: string,
    countUrl: string,
    initialOffset?: number,
    responseKey?: string
  ) => Promise<unknown[]>;
  activeTenantName: string | null | undefined;
}

export async function executeVolumesExport(
  { countUrl, dataUrl, formats, filtersForName }: VolumesExportParams,
  { fetchData, activeTenantName }: VolumesExportDeps
): Promise<void> {
  const raw = await fetchData(dataUrl, countUrl, undefined, 'volumes');
  const volumes = raw as VolumeResponse['volumes'];

  const filename = generateExportFilename(
    activeTenantName || 'Account',
    'All_Volumes_Table',
    filtersForName,
    new Date()
  );

  if (formats.includes('csv')) {
    downloadFile(toCsv(volumes.map(volumeToExportRowCsv)), `${filename}.csv`, 'text/csv;charset=utf-8;');
  }

  if (formats.includes('json')) {
    downloadFile(
      JSON.stringify(volumes.map(volumeToExportRowJson), null, 2),
      `${filename}.json`,
      'application/json'
    );
  }
}
